$ ->
  $(document)
    .on 'click', '[data-message]', (e) ->
      e.preventDefault()

      $btn = $(e.currentTarget)
      content = $btn.data('message')

      return unless content

      simple.dialog.message
        content: content
